import React from 'react'

const NewUserRegister = () => {
  return (
    <div>
        <h1>New User Register</h1>
    </div>
  )
}

export default NewUserRegister
